export default function ServicesSection() {
  return (
    <section id="services" className="py-20 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* Section Header */}
        <div className="mb-16">
          <p className="text-sm font-medium text-accent-600 tracking-wider mb-3">
            事業内容
          </p>
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950">
            4つの事業
          </h2>
        </div>

        {/* Service Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {services.map((service) => (
            <div
              key={service.key}
              className="group relative overflow-hidden rounded-2xl bg-background-50 border border-background-300 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex flex-col lg:flex-row">
                {/* Image */}
                <div className="relative w-full lg:w-2/5 aspect-[4/3] lg:aspect-auto lg:min-h-[280px] overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-background-50/40 to-transparent" />
                </div>

                {/* Content */}
                <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
                  <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mb-5 group-hover:bg-accent-200 transition-colors">
                    <i className={`${service.icon} text-xl text-accent-600`} />
                  </div>
                  <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-3">
                    {service.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {service.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const services = [
  {
    key: 'web',
    title: 'Web制作',
    desc: 'ホームページやLPの制作からスマホ対応、更新代行、保守管理まで。HTML/CSS/JSを使った丁寧なコーディングで、あなたのビジネスに最適なWebサイトを作ります。',
    icon: 'ri-global-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20laptop%20displaying%20clean%20website%20design%20on%20screen%2C%20warm%20beige%20minimalist%20workspace%2C%20soft%20natural%20window%20light%2C%20clean%20editorial%20product%20photography%20with%20warm%20neutral%20background%20and%20subtle%20shadows&width=800&height=600&seq=verite-service-web&orientation=landscape',
  },
  {
    key: 'design',
    title: 'デザイン・印刷',
    desc: 'ロゴ、チラシ、名刺、SNS画像、ポスター、パンフレットなど。デザインから印刷発注までワンストップで対応。プロのデザイナーがブランドの魅力を引き出します。',
    icon: 'ri-palette-line',
    image: 'https://readdy.ai/api/search-image?query=Graphic%20design%20materials%20arranged%20on%20light%20wooden%20desk%2C%20colorful%20brochures%20business%20cards%20and%20printing%20samples%2C%20warm%20studio%20lighting%2C%20creative%20professional%20workspace%2C%20editorial%20photography%20with%20soft%20shadows%20and%20warm%20tones&width=800&height=600&seq=verite-service-design&orientation=landscape',
  },
  {
    key: 'video',
    title: '動画制作',
    desc: 'SNS向けの短尺動画制作。TikTok、Instagram Reels、YouTube Shortsなど、トレンドに合わせた縦型・横型動画を制作。視聴者の心を掴む演出で差別化を図ります。',
    icon: 'ri-movie-2-line',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20on%20tripod%20recording%20short%20video%20content%2C%20modern%20content%20creation%20setup%20with%20ring%20light%2C%20warm%20beige%20background%2C%20editorial%20photography%20style%20with%20soft%20natural%20lighting%20and%20minimalist%20composition&width=800&height=600&seq=verite-service-video&orientation=landscape',
  },
  {
    key: 'bpo',
    title: 'BPO・事務サポート',
    desc: 'データ入力や書類スキャンなどの事務作業を代行。中小企業の煩雑な業務を肩代わりし、本業に集中できる環境を作ります。',
    icon: 'ri-file-list-3-line',
    image: 'https://readdy.ai/api/search-image?query=Organized%20office%20workspace%20with%20documents%20and%20digital%20scanner%2C%20clean%20desk%20with%20paperwork%20being%20processed%20neatly%2C%20warm%20neutral%20lighting%2C%20professional%20BPO%20support%20workspace%2C%20editorial%20photography%20with%20warm%20tones&width=800&height=600&seq=verite-service-bpo&orientation=landscape',
  },
];